module.exports = __webpack_public_path__ + "assets/analytics_marker-offMarket.2183bec0.svg";